"use client"

import { Checkbox } from "@/components/ui/checkbox"

/**
 * "Customer action required" toggle for the invoice-list filter bars —
 * sibling of `StatusFilter` / `MarketFilter` / `OwnerFilter`, shared by
 * `/invoices` and the home "My Invoices" section so the label, the
 * `aria-label` the tests key on, and the rationale live in one place.
 *
 * A checkbox rather than another status option: the state is not a status
 * — a deposit whose *balance* leg awaits the customer stays "Partially
 * Paid" — so it has to compose with the status filter rather than compete
 * with it (support-stripe-require-action-status §3.5).
 */
export function ActionRequiredFilter({
  value,
  onChange,
}: {
  value: boolean
  onChange: (next: boolean) => void
}) {
  return (
    <label className="flex items-center gap-2 text-body text-foreground">
      <Checkbox
        checked={value}
        onCheckedChange={(checked) => onChange(checked === true)}
        aria-label="Customer action required filter"
      />
      Customer action required
    </label>
  )
}
